class VariantSelectsNew extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.images = {
      46997988704539: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279676887_fire_pit_darkgray.png?v=1762148632",
      46997988770075: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279670937_fire_pit_black.png?v=1762148632",
      46997988737307: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279682200_fire_pit_lightgray_b2e994e9-5b31-4263-8431-7446e222439e.png?v=1762148632",
      48225582809371: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279687929_fire_pit_marble.png?v=1762148632",
      49507504652571: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279715328_premium_darkgray.png?v=1762148631",
      49507504718107: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279709707_premium_black.png?v=1762148632",
      49507504685339: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279720700_premium_lightgray_c2a21262-1085-4eab-8ff3-6caec96d9614.png?v=1762148631",
      49507504750875: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279725513_premium_marble.png?v=1762148632",
      48612060004635: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279559701_essential_darkgray.png?v=1762148632",
      48612060070171: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279552970_essential_black.png?v=1762148632",
      48612060037403: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279566186_essential_lightgray_fc395ce1-8c89-401e-8d9f-a6f1c6e8f554.png?v=1762148632",
      48612060102939: "https://cdn.shopify.com/s/files/1/0705/6559/3371/files/1751279571756_essential_marble.png?v=1762148632"
    };
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updatePrice();
      //this.updateURL();
      this.updateVariantInput();
      //this.renderProductInfo();
      //this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if(this.currentVariant.available){
      this.toggleAddButton(
        !this.currentVariant.available
      );
    }else{
      this.toggleAddButton(
        true,
        window.variantStrings.soldOut
      );
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    let media = this.querySelector(`.package_prod_box img`);
    media.src = this.images[this.currentVariant.id];

  }
  updatePrice(){
    if (!this.currentVariant) return;

    //for total main price
    let total_variant_price = parseInt(this.querySelector('.total-pdp-main-price').dataset.price);
    let total_variant__comp_price = parseInt(this.querySelector('.total-pdp-comp-price').dataset.price);

    if(this.currentVariant.title.indexOf('Marble')!== -1){
      total_variant_price += 2000;
      total_variant__comp_price += 2000;
    }

    let total_comp_price_elem = this.querySelectorAll('.total-pdp-comp-price');
    total_comp_price_elem.forEach(element => {
      if(element) {
        if(total_variant__comp_price > total_variant_price) {
          element.innerHTML = formatMoney(total_variant__comp_price, window.money_format);
        } else{
          element.innerHTML = '';
        }
      }
    });

    let total_main_price_elem = this.querySelectorAll('.total-pdp-main-price');
    total_main_price_elem.forEach(element => {
      element.innerHTML = formatMoney(total_variant_price, window.money_format);
    });
    let savings = this.querySelector('.package-tsave-text');
    if (savings && total_variant__comp_price > total_variant_price){
      let total_savings = total_variant__comp_price - total_variant_price;
      savings.innerHTML = `<p>Your Total Savings Today: ${formatMoney(total_savings, window.money_format)}</p>`;
    } else{
      savings.innerHTML = '';
    }



    // for table price


    let variant_price = parseInt(this.querySelector('.pdp-main-price').dataset.price);
    let compare_at_price = parseInt(this.querySelector('.pdp-comp-price').dataset.price);
    if(this.currentVariant.title.indexOf('Marble')!== -1){
      variant_price += 2000;
      compare_at_price += 2000;
    }

    let comp_price_elem = this.querySelectorAll('.pdp-comp-price');
    comp_price_elem.forEach(element => {
      if(element) {
        if(compare_at_price > variant_price) {
          element.innerHTML = formatMoney(compare_at_price, window.money_format);
        } else{
          element.innerHTML = '';
        }
      }
    });
    
    let main_price_elem = this.querySelectorAll('.pdp-main-price');
    main_price_elem.forEach(element => {
      element.innerHTML = formatMoney(variant_price, window.money_format);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    if (this.dataset.type === 'duplicate' && this.querySelector('input:checked') && this.querySelector('input:checked').getAttribute('original-pro-id')) {
      window.history.replaceState({}, '', `${this.dataset.originalUrl}?variant=${this.querySelector('input:checked').getAttribute('original-pro-id')}`);
    }else{
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        
        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination && !destination.classList.contains('no-update') && this.dataset.type !== 'duplicate' ) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      document.body.classList.remove('pd-in-stock');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = this.dataset.btnText;
      document.body.classList.add('pd-in-stock');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects-new', VariantSelectsNew);

class VariantRadiosNew extends VariantSelectsNew {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios-new', VariantRadiosNew);



//others
$('body').on('click', '.choosehdng', function(){
    $(this).closest('.selct-colorbx').find('.color-drower').slideToggle();
});
$('body').on('change', '.color-drower input', function(){
    let label = $(this).next('label');
    $(this).closest('.selct-colorbx').find('.color-drower').slideUp();
    updateHeading(label,$(this).closest('.selct-colorbx').find('.choosehdng_inn'));
    $(this).closest('.selct-color-outer').find('.select-color-heading span').html(label.find('.option-value').html());
});

function updateHeading(source, target) {
  const $source = $(source);
  const $target = $(target);

  // Clone the source contents
  const $content = $source.contents().clone();

  // Replace target content
  $target.empty().append($content);
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] && parts[1] !== '00' ? decimal + parts[1] : ''; // ✅ Remove .00 if unnecessary

    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);

  if (match) {
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

//call with == formatMoney(1999, window.money_format);


// mobile bottom sticky
// const checkVisibility = () => {
//   const btnBox = document.querySelector('.brings_banner .brings_banner_left');
//   const giftSection = document.querySelector('.gift_choose_section .package_main');
//   const mobileBtnBox = document.querySelector('.mobile_btn_box');
//   const stickyHeaderHeight = document.querySelector('.sticky-headers')?.offsetHeight || 0;
//   const topBarHeight = document.querySelector('.top_bar')?.offsetHeight || 0;
//   const isOutsideViewport = (el) => {
//     const rect = el.getBoundingClientRect();
//     return rect.bottom < stickyHeaderHeight + topBarHeight || rect.top > window.innerHeight;
//   };


//   if (isOutsideViewport(btnBox) && isOutsideViewport(giftSection)) {
//     mobileBtnBox.classList.add('active');
//   } else {
//     mobileBtnBox.classList.remove('active');
//   }
// };
// window.addEventListener('scroll', checkVisibility);
// checkVisibility();
const mobileBtnBox = document.querySelector('.mobile_btn_box:not(.mobile_new)');
const sections = document.querySelectorAll('.gift_choose_section, .brings_banner,.shopify-section-group-footer-group');

// Track visibility of each section
let visibleSections = new Set();

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Section is visible
      visibleSections.add(entry.target);
    } else {
      // Section is completely out of view
      visibleSections.delete(entry.target);
    }
  });

  // If none of the target sections are visible → activate sticky button
  if (visibleSections.size === 0) {
    mobileBtnBox.classList.add('active');
  } else {
    mobileBtnBox.classList.remove('active');
  }
}, {
  root: null,
  threshold: 0 // triggers even if 1px is visible
});

// Observe both sections
sections.forEach(section => observer.observe(section));

// all color change 
document.body.addEventListener('click', function (e) {
  const el = e.target.closest('.gift_choose_color .color-option-col:not(.active)');
  if (!el) return;

  // Remove old active class
  const wrapper = el.closest('.gift_choose_color');
  wrapper.querySelectorAll('.color-option-col.active').forEach((c) => c.classList.remove('active'));
  el.classList.add('active');

  const active_value = el.getAttribute('data-value');
  const inputs = document.querySelectorAll(`.package_main input[value="${active_value}"]`);

  inputs.forEach((input, index) => {
    input.checked = true;
    const event = new Event('change', { bubbles: true });
    input.dispatchEvent(event);

    if (window.jQuery) {
      $(input).trigger('change');
    }
  });
});

$('body').on('click', '.custom_btn', function(e) {
  e.preventDefault(); 
    if(window.screen.width > 768){
        var spacing_top = 100;
    }else {
        var spacing_top = 80;
    }
  
  $('html, body').animate({
    scrollTop: $('.gift_choose_section').offset().top -spacing_top
  }, 600); // 600ms = smooth scroll duration
});


// 10 min countdown timer
// Initial time in seconds (10 minutes = 600 seconds)
let timeLeft = (10 * 60) - 1;

const countdownEl = document.querySelector('#countdown');
if(countdownEl){
  const timer = setInterval(() => {
    // Calculate minutes and seconds
    let minutes = Math.floor(timeLeft / 60);
    let seconds = timeLeft % 60;

    // Format with leading zeros
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    // Update display
    countdownEl.textContent = `${minutes}:${seconds}`;

    // Stop when it reaches 0
    if (timeLeft <= 0) {
      clearInterval(timer);
      countdownEl.textContent = "00:00";
    }

    timeLeft--;
  }, 1000);
}